import { Gray_Light_200 } from '@common/styles';

export const GeneralArrowRightIcon = ({
  width = 8,
  height = 16,
  color = Gray_Light_200,
  ...props
}: JSX.IntrinsicElements['svg']) => (
  <svg width={width} height={height} color={color} viewBox='0 0 8 16' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.50001 1.93933L0.439349 2.99999L5.43901 7.99999L0.439349 13L1.50001 14.0607L7.56067 7.99999L1.50001 1.93933Z'
      fill='currentColor'
    />
  </svg>
);
